module.exports = __webpack_public_path__ + "img/Rockport-dry.4dca4f7f.jpg";